import * as Booking from '../constants/Booking';

// the flat timeslot api only depends on the date and the branch
export const getTimeslotParams = (form) => ({
    date: form[Booking.FieldNames.date],
    branchId: form[Booking.FieldNames.location] ? form[Booking.FieldNames.location] : null,
});

export const isSameTimeslotParams = (a, b) => !!a && !!b && a.date === b.date && a.branchId === b.branchId;

// true while the timeslots in the store are not the ones of the current form yet,
// e.g. the previous date's slots are still shown while the new date loads
export const isTimeslotDataPending = (booking) => {
    const { selectedBookingItem, form, timeslotParams, loadingTimeslotGroup } = booking;

    if (selectedBookingItem.source?.timeslotGroupOn) return loadingTimeslotGroup;

    return !isSameTimeslotParams(timeslotParams, getTimeslotParams(form));
};
